import { Colors } from '@sigma-frontend-libs/commons'

import { components, generateUniqueKey, getServiceComponent } from '@/utils'

function renderItem(h, { name, meta }) {
  const { navIcon, navType, params, color, iconColor } = meta || {}
  const active = this.$route.matched.some(({ name: routeName }) => {
    return routeName === name
  })
  const props = {
    color,
    icon: navIcon,
    iconColor: iconColor,
    label: this.getTranslate(`${meta.pathToTitle || name}.title`),
    active,
    dense: true
  }
  const nativeOn = {}

  if (!navType || navType !== 'group') {
    props.to = {
      name,
      params
    }

    if (this.viewport.breakpoint.smDown) {
      nativeOn.click = () => {
        return this.$emit('click', false)
      }
    }
  }

  const scopedSlots = {}
  if (meta.suffix) {
    const service = meta.originalServiceName || name
    scopedSlots.suffix = () => {
      let color = Colors.grey
      if (props.active) {
        color = Colors.primary
      }

      return h(
        getServiceComponent(`${service}/${meta.suffix}`),
        {
          props: {
            color,
            service
          }
        }
      )
    }
  }

  return h(
    components['list-item'],
    {
      props,
      scopedSlots,
      nativeOn,
      key: generateUniqueKey()
    }
  )
}

function renderItemByType(h, { name, meta, children }) {
  const { permission, permissionAccept, navType } = meta || {}

  if (permission) {
    if (!this.checkPermissions(permission, permissionAccept)) {
      return
    }
  }

  switch (navType) {
    case 'subheader': {
      return h(
        'g-subheader',
        {
          class: 'plpx-40',
          props: { dense: true }
        },
        [ this.getTranslate(`commons.subheader.${name}`) ]
      )
    }

    case 'group': {
      return h(
        components['list-group'],
        {
          props: {
            icon: meta.navIcon,
            label: this.getTranslate(`${meta.pathToTitle || name}.title`),
            active: !!~this.$route.path.split('/').indexOf(name),
            dense: true
          }
        },
        [
          children.map(child => {
            return renderItem.call(this, h, child)
          })
        ]
      )
    }

    case 'item':
    default: {
      return renderItem.call(
        this,
        h,
        {
          name,
          meta
        }
      )
    }
  }
}

export default function(h) {
  return h(
    components.list,
    {
      props: { dense: true }
    },
    this.routes.map(({ name, meta, children }) => {
      return renderItemByType.call(
        this,
        h,
        {
          name,
          meta,
          children
        }
      )
    })
  )
}
